import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { taxId, conpanyName, releaseDate, representative, totalTax },
} = checkout;

const validation = Yup.object().shape({
  [totalTax.name]: Yup.string().required(totalTax.errorMsg),
  [conpanyName.name]: Yup.string().required(conpanyName.errorMsg),
  [releaseDate.name]: Yup.string().required(releaseDate.errorMsg),
  [representative.name]: Yup.string().required(representative.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
